import { render, staticRenderFns } from "./TheDoctorNavbarVertical.vue?vue&type=template&id=fd27fc6e&"
import script from "./TheDoctorNavbarVertical.vue?vue&type=script&lang=js&"
export * from "./TheDoctorNavbarVertical.vue?vue&type=script&lang=js&"
import style0 from "./TheDoctorNavbarVertical.vue?vue&type=style&index=0&id=fd27fc6e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports